import { connect } from 'react-redux';
import { getDashboardsList, getInsightsLoading } from 'core/selectors';
import { fetchUserDashboards } from 'core/slices/insights';
import InsightsDashboardsComponent from '../../../components/insights/InsightsDashboards';

export default connect(
  state => ({
    dashboards: getDashboardsList(state),
    loading: getInsightsLoading(state),
  }),
  {
    fetchUserDashboards,
  },
)(InsightsDashboardsComponent);
